import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faCalendarDays,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faEnvelope,
	faPhone,
	faChevronUp,
	faGlobe,
	faXmark,
} from '@fortawesome/pro-light-svg-icons';

import {
	faFacebookSquare,
	faFacebook,
	faInstagramSquare,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTiktok,
	faTwitterSquare,
	faWhatsapp,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';

import {
	faArrows,
	faBars,
	faEuroSign,
	faMinus,
	faPlay,
	faPlus,
	faSearch,
	faStar,
	faTimes,
	faQuoteLeft,
	faStarHalf,
	faUsers,
} from '@fortawesome/pro-solid-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faArrows,
	faBars,
	faChevronUp,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faCalendarDays,
	faEnvelope,
	faEuroSign,
	faGlobe,
	faQuoteLeft,
	faFacebook,
	faFacebookSquare,
	faInstagramSquare,
	faLinkedin,
	faMinus,
	faPinterest,
	faPhone,
	faPlay,
	faPlus,
	faSearch,
	faSoundcloud,
	faSpotify,
	faInstagram,
	faTiktok,
	faTimes,
	faTwitterSquare,
	faUsers,
	faWhatsapp,
	faYoutube,
	faXmark,
	faStar,
	faStarHalf,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
